<template>
    <div class="p-2 row-gap row-gap-10-px">
        <div class="line">
            <div class="field-item">
                <div class="lable_item">統括部</div>
                <div class="item-group input-search-area input-no-required">
                    <ans-input-search
                        id="external-md"
                        type="number"
                        input-class="custom-border width-70-px"
                        v-model="data.external.MDCD"
                        :maxLength="5"
                        :onChangeInput="(index, value) => $emit('refer-md', index, value, data.external)"
                        :is-show-clear="false"
                        page-search="PopupMST005"
                        :data-extra="{ company_cd: user.company_cd }"
                        :auto-close="true"
                        :isReadonly="false"
                        @onReferValueName="(value) => $emit('get-md-name', value, data.external)"
                        :isDisabled="!user.company_cd"
                        :isDisabledInput="!user.company_cd"
                    />
                    <div class="w-100">
                        <ans-input
                            input-class="span-input not_set overflow-dot border-none-dm"
                            v-model="data.external.MDName"
                            id="MDName"
                            is-required
                            :maxLength="100"
                            :isDisabled="true"
                        />
                    </div>
                </div>
            </div>
        </div>
        <div class="line">
            <div class="field-item">
                <div class="lable_item">取引先</div>
                <div class="item-group input-search-area input-no-required">
                    <ans-input-search
                        type="number"
                        input-class="custom-border width-70-px"
                        v-model="data.external.ClientCD"
                        :maxLength="8"
                        :onChangeInput="(index, value) => $emit('refer-client', index, value, data.external)"
                        :is-show-clear="false"
                        page-search="PopupMST001"
                        :data-extra="{ company_cd: user.company_cd }"
                        :auto-close="true"
                        :isReadonly="false"
                        :isDisabled="!user.company_cd"
                        :isDisabledInput="!user.company_cd"
                        @onReferValueName="(value) => $emit('get-client-name', value, data.external)"
                    />
                    <div class="w-100">
                        <ans-input
                            input-class="span-input not_set overflow-dot border-none-dm"
                            v-model="data.external.ClientName"
                            id="ClientName"
                            is-required
                            :maxLength="100"
                            :isDisabled="true"
                        />
                    </div>
                </div>
            </div>
        </div>
        <div class="line">
            <div class="field-item">
                <div class="lable_item">拠点CD</div>
                <div class="item-group input-search-area input-no-required">
                    <ans-input-search
                        id="branch_cd"
                        v-model="data.external.BranchCD"
                        input-class="custom-border"
                        :is-show-clear="false"
                        :maxLength="4"
                        page-search="PopupMST002"
                        :auto-close="true"
                        icon="fas fa-search"
                        :isReadonly="!user.company_cd || !data.external.ClientCD"
                        type="number"
                        :onChangeInput="(index, value) => $emit('refer-branch', index, value, data.external)"
                        @onReferValueName="(value) => $emit('get-branch-name', value, data.external)"
                        :data-extra="{ company_cd: user.company_cd, customer_cd: data.external.ClientCD, mdcd: data.external.MDCD }"
                        :isDisabled="!user.company_cd || !data.external.ClientCD"
                        :isDisabledInput="!user.company_cd || !data.external.ClientCD"
                    />
                    <div class="w-100">
                        <ans-input
                            input-class="span-input not_set overflow-dot border-none-dm"
                            v-model="data.external.BranchName"
                            id="BranchName"
                            is-required
                            :maxLength="100"
                            :isDisabled="true"
                        />
                    </div>
                </div>
            </div>
        </div>
        <div class="line">
            <div class="field-item">
                <div class="lable_item">担当者</div>
                <div class="item-group input-search-area input-no-required">
                    <ans-input-search
                        id="UserID"
                        type="number"
                        input-class="custom-border"
                        v-model="data.external.UserID"
                        :maxLength="3"
                        :onChangeInput="(index, value) => $emit('refer-user', index, value, data.external)"
                        :is-show-clear="false"
                        page-search="PopupMST003"
                        :auto-close="true"
                        :isReadonly="!user.company_cd || !data.external.ClientCD || !data.external.BranchCD"
                        @onReferValueName="(value) => $emit('get-user-name', value, data.external)"
                        :data-extra="{ company_cd: user.company_cd, customer_cd: data.external.ClientCD, location_cd: data.external.BranchCD }"
                        :isDisabled="!user.company_cd || !data.external.ClientCD || !data.external.BranchCD"
                        :isDisabledInput="!user.company_cd || !data.external.ClientCD || !data.external.BranchCD"
                        :isRequired-background="true"
                    />
                    <div class="w-100">
                        <ans-input
                            input-class="span-input not_set overflow-dot border-none-dm"
                            v-model="data.external.UserName"
                            id="UserName"
                            is-required
                            :maxLength="100"
                            :isDisabled="true"
                        />
                    </div>
                </div>
            </div>
        </div>
        <div class="line">
            <div class="field-item">
                <div class="lable_item">件名</div>
                <div class="item-group input-no-required">
                    <ans-input
                        id="Subject"
                        input-class="custom-border"
                        :maxLength="100"
                        v-model="data.external.Subject"
                        is-enable-i-m-e
                        is-required
                    />
                </div>
            </div>
        </div>
        <div class="line">
            <div class="field-item">
                <div class="lable_item h-100">メッセージ</div>
                <div class="item-group">
                    <ans-input
                        id="Body"
                        type="textarea"
                        :rows="4"
                        input-class="custom-border"
                        :maxLength="100"
                        v-model="data.external.Body"
                        is-enable-i-m-e
                        is-required
                    />
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import { mapState } from 'vuex';

export default {
    name: 'ComposeExternal',
    computed: { ...mapState('app', ['user', 'isShowLeftMenu', 'dmMessageMode']), ...mapState('MNG_DM_Message_Store', ['data', 'options']) }
};
</script>
